(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-atelier-pdp]');
    const panels = document.querySelectorAll('[data-atelier-purchase-panel]');

    if (!section || !panels.length) {
      return;
    }

    const cartUrl = () => {
      const routes = window.theme && window.theme.routes;
      const themeCartUrl = routes && routes.cart_url ? routes.cart_url : '/cart';
      return `${themeCartUrl.replace(/\/$/, '')}.js`;
    };

    const getCart = () => {
      return fetch(cartUrl(), {
        headers: {
          Accept: 'application/json',
        },
      }).then((response) => response.json());
    };

    const updatePanelState = (panel, cart) => {
      const variantId = Number(panel.dataset.atelierVariantId);
      const isAvailable = panel.dataset.atelierAvailable === 'true';
      const cartItems = cart && Array.isArray(cart.items) ? cart.items : [];
      const inCart = cartItems.some((item) => Number(item.variant_id || item.id) === variantId);
      const button = panel.querySelector('[data-add-to-cart]');
      const buttonText = panel.querySelector('[data-atelier-add-button-text]');
      const note = panel.querySelector('[data-atelier-cart-note]');
      const errors = panel.querySelector('[data-cart-errors-container]');

      panel.dataset.atelierInCart = inCart ? 'true' : 'false';
      panel.dataset.atelierCartChecked = 'true';

      if (!button || !isAvailable) {
        return;
      }

      if (inCart) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('atelier-pdp__add-button--in-cart');

        if (buttonText) {
          buttonText.textContent = panel.dataset.atelierInCartText;
        }

        if (note) {
          note.textContent = panel.dataset.atelierInCartNote;
          note.hidden = false;
        }

        if (errors) {
          errors.textContent = '';
        }

        return;
      }

      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('atelier-pdp__add-button--in-cart');

      if (buttonText) {
        buttonText.textContent = panel.dataset.atelierAddText;
      }

      if (note) {
        note.hidden = true;
      }
    };

    const refreshPanels = () => {
      getCart()
        .then((cart) => {
          panels.forEach((panel) => updatePanelState(panel, cart));
        })
        .catch(() => {
          panels.forEach((panel) => {
            panel.dataset.atelierCartChecked = 'unavailable';
          });
        });
    };

    const refreshPanelsAfterCartMutation = () => {
      window.setTimeout(refreshPanels, 700);
      window.setTimeout(refreshPanels, 1600);
    };

    panels.forEach((panel) => {
      const form = panel.querySelector('[data-atelier-product-form]');

      if (!form) {
        return;
      }

      const resizeField = form.querySelector('[data-atelier-resize-field]');
      const resizePreferenceInputs = Array.from(form.querySelectorAll('[data-atelier-resize-preference]'));
      const resizePreferenceError = form.querySelector('[data-atelier-resize-error]');
      const addButton = form.querySelector('[data-add-to-cart]');

      const setResizePreferenceValidity = () => {
        if (!resizePreferenceInputs.length) {
          return true;
        }

        const hasSelection = resizePreferenceInputs.some((input) => input.checked);
        const requiredMessage = resizeField ? resizeField.dataset.requiredMessage : '';
        const firstInput = resizePreferenceInputs[0];

        if (firstInput) {
          firstInput.setCustomValidity(hasSelection ? '' : requiredMessage);
        }

        resizePreferenceInputs.forEach((input) => {
          input.setAttribute('aria-invalid', hasSelection ? 'false' : 'true');
        });

        if (resizePreferenceError) {
          resizePreferenceError.textContent = hasSelection ? '' : requiredMessage;
          resizePreferenceError.hidden = hasSelection;
        }

        return hasSelection;
      };

      const guardResizePreference = (event) => {
        if (setResizePreferenceValidity()) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (resizePreferenceInputs[0]) {
          resizePreferenceInputs[0].focus();
        }
      };

      resizePreferenceInputs.forEach((input) => {
        input.addEventListener('change', setResizePreferenceValidity);
      });

      if (addButton) {
        addButton.addEventListener('click', guardResizePreference, true);
      }

      form.addEventListener(
        'submit',
        (event) => {
          if (!setResizePreferenceValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (resizePreferenceInputs[0]) {
              resizePreferenceInputs[0].focus();
            }

            return;
          }

          if (panel.dataset.atelierInCart !== 'true') {
            refreshPanelsAfterCartMutation();
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          updatePanelState(panel, {
            items: [
              {
                variant_id: Number(panel.dataset.atelierVariantId),
              },
            ],
          });
        },
        true
      );
    });

    document.querySelectorAll('[data-atelier-boutique-add]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const targetSelector = trigger.dataset.atelierPurchaseTarget;
        const panel = targetSelector ? document.querySelector(targetSelector) : section.querySelector('[data-atelier-purchase-panel]');
        const addButton = panel ? panel.querySelector('[data-add-to-cart]') : null;

        if (!panel || !addButton) {
          return;
        }

        panel.scrollIntoView({behavior: 'smooth', block: 'center'});

        window.setTimeout(() => {
          addButton.click();
        }, 250);
      });
    });

    const closeActiveDrawer = () => {
      const activeDrawer = document.querySelector('[data-atelier-drawer].is-open');

      if (!activeDrawer) {
        return;
      }

      const drawerScroller = activeDrawer.querySelector('[data-scroll]') || activeDrawer;
      activeDrawer.setAttribute('aria-hidden', 'true');
      activeDrawer.classList.remove('is-open');
      document.body.classList.remove('js-drawer-open');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true, detail: drawerScroller}));

      document.querySelectorAll(`[aria-controls="${activeDrawer.id}"]`).forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      window.setTimeout(() => {
        activeDrawer.classList.add('cv-h');
      }, 350);
    };

    document.querySelectorAll('[data-atelier-drawer-toggle]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const drawerId = button.getAttribute('aria-controls');
        const drawer = drawerId ? document.getElementById(drawerId) : null;

        if (!drawer) {
          return;
        }

        if (drawer.classList.contains('is-open')) {
          closeActiveDrawer();
          return;
        }

        closeActiveDrawer();

        const drawerScroller = drawer.querySelector('[data-scroll]') || drawer;
        drawer.classList.remove('cv-h');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        document.body.classList.add('js-drawer-open');
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: drawerScroller}));
      });
    });

    document.addEventListener('click', (event) => {
      const activeDrawer = document.querySelector('[data-atelier-drawer].is-open');

      if (!activeDrawer) {
        return;
      }

      const isToggle = event.target.closest('[data-atelier-drawer-toggle]');

      if (!isToggle && !activeDrawer.contains(event.target)) {
        closeActiveDrawer();
      }
    });

    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        closeActiveDrawer();
      }
    });

    const enquiryModal = document.querySelector('[data-atelier-enquiry-modal]');
    const enquiryPanel = enquiryModal ? enquiryModal.querySelector('.atelier-pdp__enquiry-panel') : null;
    const enquiryTriggers = document.querySelectorAll('[data-atelier-enquiry-open]');

    const populateEnquiryContext = (trigger) => {
      if (!enquiryModal) {
        return;
      }

      const context = {
        product__title: trigger.dataset.productTitle || enquiryModal.dataset.productTitle || '',
        product_title: trigger.dataset.productTitle || enquiryModal.dataset.productTitle || '',
        product_handle: trigger.dataset.productHandle || enquiryModal.dataset.productHandle || '',
        product_url: trigger.dataset.productUrl || enquiryModal.dataset.productUrl || window.location.href,
        page_url: trigger.dataset.productUrl || enquiryModal.dataset.productUrl || window.location.href,
        product__url: trigger.dataset.productUrl || enquiryModal.dataset.productUrl || window.location.href,
        variant_id: trigger.dataset.variantId || enquiryModal.dataset.variantId || '',
        variant: trigger.dataset.variantId || enquiryModal.dataset.variantId || '',
        sku: trigger.dataset.sku || enquiryModal.dataset.sku || '',
      };

      Object.keys(context).forEach((name) => {
        const fields = enquiryModal.querySelectorAll(`[name="${name}"], [name="${name.replace(/_/g, ' ')}"], [name="${name.replace(/__/g, ' ').replace(/_/g, ' ')}"]`);
        fields.forEach((field) => {
          field.value = context[name];
        });
      });

      enquiryModal.dataset.atelierContextPopulated = 'true';
      enquiryModal.dataset.atelierContextTitle = context.product_title;
      enquiryModal.dataset.atelierContextHandle = context.product_handle;
      enquiryModal.dataset.atelierContextUrl = context.product_url;
      enquiryModal.dataset.atelierContextVariant = context.variant_id;
    };

    const closeEnquiry = () => {
      if (!enquiryModal) {
        return;
      }

      enquiryModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('atelier-enquiry-open');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    };

    const openEnquiry = (event) => {
      const trigger = event.currentTarget;
      event.preventDefault();
      const url = new URL(trigger.getAttribute('href'), window.location.origin);
      if (trigger.dataset.variantId) url.searchParams.set('variant_id', trigger.dataset.variantId);
      if (trigger.dataset.sku) url.searchParams.set('sku', trigger.dataset.sku);
      window.location.assign(url.href);
    };

    enquiryTriggers.forEach((trigger) => {
      trigger.addEventListener('click', openEnquiry);
    });

    if (enquiryModal) {
      enquiryModal.querySelectorAll('[data-atelier-enquiry-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', closeEnquiry);
      });

      document.addEventListener('keyup', (event) => {
        if (event.code === 'Escape' && enquiryModal.getAttribute('aria-hidden') === 'false') {
          closeEnquiry();
        }
      });
    }

    const lightboxLinks = Array.from(document.querySelectorAll('[data-atelier-lightbox-trigger]'));
    let atelierPhotoSwipePromise = null;

    const loadAtelierPhotoSwipe = () => {
      if (window.themePhotoswipe && window.themePhotoswipe.PhotoSwipe && window.themePhotoswipe.PhotoSwipeUI) {
        return Promise.resolve();
      }

      if (atelierPhotoSwipePromise) {
        return atelierPhotoSwipePromise;
      }

      atelierPhotoSwipePromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector('script[data-atelier-photoswipe-loader]');

        if (existingScript) {
          existingScript.addEventListener('load', resolve, {once: true});
          existingScript.addEventListener('error', reject, {once: true});
          return;
        }

        const script = document.createElement('script');
        script.src = (window.theme && window.theme.assets && window.theme.assets.photoswipe) || section.dataset.atelierPhotoswipeSrc || '';
        script.async = true;
        script.setAttribute('data-atelier-photoswipe-loader', 'true');
        script.addEventListener('load', resolve, {once: true});
        script.addEventListener('error', reject, {once: true});
        document.head.appendChild(script);
      });

      return atelierPhotoSwipePromise;
    };

    const openAtelierLightbox = (index) => {
      const pswpElement = document.querySelector('.pswp');

      if (!pswpElement || !window.themePhotoswipe || !window.themePhotoswipe.PhotoSwipe) {
        return;
      }

      const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
      const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
      const items = lightboxLinks.map((link) => ({
        src: link.getAttribute('href'),
        w: parseInt(link.dataset.imageWidth, 10) || 1600,
        h: parseInt(link.dataset.imageHeight, 10) || 1600,
        msrc: link.getAttribute('href'),
      }));
      const productType = section.dataset.atelierProductType || '';
      const lightboxClass = productType === 'ring' ? 'pswp-zoom-gallery atelier-pdp__lightbox atelier-pdp__lightbox--ring' : 'pswp-zoom-gallery atelier-pdp__lightbox';
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI, items, {
        barsSize: {top: 60, bottom: 60},
        history: false,
        focus: false,
        index,
        mainClass: lightboxClass,
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar', 'button--close', 'custom-close', 'ui-over-close', 'caption-close'],
        tapToClose: true,
        clickToCloseNonZoomable: false,
        zoomEl: false,
        shareEl: false,
        fullscreenEl: false,
        counterEl: true,
        arrowEl: true,
        getDoubleTapZoom: (isMouseClick, item) => item.initialZoomLevel,
        maxSpreadZoom: 1,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
      });

      const closeControls = Array.from(pswpElement.querySelectorAll('.pswp__button--close, .pswp__custom-close, .pswp__caption-close'));
      const closeLightbox = (event) => {
        event.preventDefault();
        event.stopPropagation();
        gallery.close();
      };

      closeControls.forEach((control) => {
        control.addEventListener('click', closeLightbox);
      });

      gallery.listen('close', () => {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      });

      gallery.listen('destroy', () => {
        closeControls.forEach((control) => {
          control.removeEventListener('click', closeLightbox);
        });
      });

      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
      gallery.init();
    };

    lightboxLinks.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const explicitIndex = parseInt(link.dataset.atelierLightboxIndex, 10);
        const lightboxIndex = Number.isNaN(explicitIndex) ? index : explicitIndex;

        loadAtelierPhotoSwipe()
          .then(() => openAtelierLightbox(lightboxIndex))
          .catch(() => {
            window.location.href = link.getAttribute('href');
          });
      });
    });

    document.addEventListener('DOMContentLoaded', refreshPanels);
    window.addEventListener('pageshow', refreshPanels);
    document.addEventListener('theme:cart:added', refreshPanels);
    document.addEventListener('theme:cart:update', refreshPanels);
    document.addEventListener('theme:cart:loaded', refreshPanels);
    document.addEventListener('theme:cart:close', refreshPanels);

    refreshPanels();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var enquiryButton = event.target.closest('[data-bespoke-enquiry]');
    if (enquiryButton) {
      var section = enquiryButton.closest('[data-bespoke-section]');
      var modal = section ? section.querySelector('[data-bespoke-modal]') : null;
      var formId = enquiryButton.getAttribute('data-klaviyo-form-id');

      if (modal) {
        modal.hidden = false;
      }

      if (formId) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      }
    }

    var closeButton = event.target.closest('[data-bespoke-modal-close]');
    if (closeButton) {
      var openModal = closeButton.closest('[data-bespoke-modal]');
      if (openModal) {
        openModal.hidden = true;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemstone-pdp-prototype"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGemstoneGalleries = (scope = document) => {
      const roots = scope.querySelectorAll('[data-gemstone-gallery]');

      roots.forEach((root) => {
        if (root.dataset.gemstoneGalleryReady === 'true') return;

        const gallery = root.querySelector('[data-gemstone-gallery-track]');
        const panels = [...root.querySelectorAll('[data-gemstone-media-panel]')];
        const count = root.querySelector('[data-gemstone-gallery-count]');
        const progress = root.querySelector('[data-gemstone-gallery-progress]');
        const previous = root.querySelector('[data-gemstone-gallery-previous]');
        const next = root.querySelector('[data-gemstone-gallery-next]');
        const desktop = window.matchMedia('(min-width: 990px)');

        if (!gallery || panels.length < 2 || !count || !previous || !next) return;

        root.dataset.gemstoneGalleryReady = 'true';
        let current = 0;
        let scrollFrame = null;
        const format = (value) => String(value).padStart(2, '0');

        const render = (index, options = {}) => {
          current = Math.max(0, Math.min(index, panels.length - 1));
          panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === current));
          count.textContent = `${format(current + 1)} / ${format(panels.length)}`;
          if (progress) progress.style.width = `${((current + 1) / panels.length) * 100}%`;
          previous.disabled = current === 0;
          next.disabled = current === panels.length - 1;

          if (options.scroll && !desktop.matches) {
            gallery.scrollTo({ left: panels[current].offsetLeft, behavior: 'smooth' });
          }
        };

        previous.addEventListener('click', () => render(current - 1, { scroll: true }));
        next.addEventListener('click', () => render(current + 1, { scroll: true }));

        gallery.addEventListener('scroll', () => {
          if (desktop.matches) return;
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            const nearest = panels.reduce((best, panel, index) => {
              const distance = Math.abs(panel.offsetLeft - gallery.scrollLeft);
              return distance < best.distance ? { index, distance } : best;
            }, { index: 0, distance: Infinity });
            if (nearest.index !== current) render(nearest.index);
          });
        }, { passive: true });

        desktop.addEventListener('change', () => render(current));
        render(0);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initGemstoneGalleries());
    } else {
      initGemstoneGalleries();
    }

    document.addEventListener('shopify:section:load', (event) => initGemstoneGalleries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molten-bespoke-approved"]) return;
  try {
    
if (!customElements.get('bespoke-detail-film')) {
  customElements.define('bespoke-detail-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.failed = false;
      this.still = () => { this.video.pause(); this.video.hidden = true; };
      this.reconcile = () => {
        if (this.failed || this.reduce.matches) { this.still(); return; }
        if (this.inView && !document.hidden) this.video.play().catch(this.still);
        else this.video.pause();
      };
      this.video.addEventListener('playing', () => {
        if (this.failed || this.reduce.matches || !this.inView || document.hidden) this.still();
        else this.video.hidden = false;
      }, options);
      this.video.addEventListener('error', () => { this.failed = true; this.still(); }, options);
      this.reduce.addEventListener('change', this.reconcile, options);
      document.addEventListener('visibilitychange', this.reconcile, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.reconcile();
      }, {threshold: 0.3});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molten-gemstone-library-destination"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activatePreview = (group, targetName) => {
      group.querySelectorAll('[data-preview-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.previewPanel === targetName);
      });
    };

    const initDiscovery = (root) => {
      if (!root || root.dataset.editorialDiscoveryInitialized === 'true') return;
      root.dataset.editorialDiscoveryInitialized = 'true';

      root.querySelectorAll('[data-preview-group]').forEach((group) => {
        const rows = [...group.querySelectorAll('[data-preview-target]')];
        const usesTouchPreview = group.hasAttribute('data-touch-preview');
        let pointerType = '';

        rows.forEach((row) => {
          const preview = () => activatePreview(group, row.dataset.previewTarget);

          row.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse' || event.pointerType === '') preview();
          });

          row.addEventListener('focus', preview);

          if (!usesTouchPreview) return;

          row.addEventListener('pointerdown', (event) => {
            pointerType = event.pointerType;
          });

          row.addEventListener('click', (event) => {
            const isTouchOrPen = pointerType === 'touch' || pointerType === 'pen';
            pointerType = '';
            if (!isTouchOrPen || row.classList.contains('is-previewed')) return;

            event.preventDefault();
            rows.forEach((item) => item.classList.remove('is-previewed'));
            row.classList.add('is-previewed');
            preview();
          });
        });

        group.addEventListener('focusout', (event) => {
          if (group.contains(event.relatedTarget)) return;
          rows.forEach((row) => row.classList.remove('is-previewed'));
        });
      });

      const mobileTriggers = [...root.querySelectorAll('.ms-gemlib__discovery-mobile-trigger')];
      root.classList.add('is-enhanced');

      mobileTriggers.forEach((trigger, index) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const icon = trigger.querySelector('.ms-gemlib__discovery-mobile-icon');
        const isInitiallyOpen = index === 0;
        trigger.setAttribute('aria-expanded', String(isInitiallyOpen));
        if (panel) panel.hidden = !isInitiallyOpen;
        if (icon) icon.textContent = isInitiallyOpen ? '−' : '+';

        trigger.addEventListener('click', () => {
          const currentlyExpanded = trigger.getAttribute('aria-expanded') === 'true';

          mobileTriggers.forEach((item) => {
            const itemPanel = document.getElementById(item.getAttribute('aria-controls'));
            const itemIcon = item.querySelector('.ms-gemlib__discovery-mobile-icon');
            item.setAttribute('aria-expanded', 'false');
            if (itemPanel) itemPanel.hidden = true;
            if (itemIcon) itemIcon.textContent = '+';
          });

          if (currentlyExpanded) return;
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
          if (icon) icon.textContent = '−';
        });
      });
    };

    const initAllDiscoveries = (container = document) => {
      if (container.matches && container.matches('[data-editorial-discovery]')) initDiscovery(container);
      container.querySelectorAll('[data-editorial-discovery]').forEach(initDiscovery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllDiscoveries());
    } else {
      initAllDiscoveries();
    }

    document.addEventListener('shopify:section:load', (event) => initAllDiscoveries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molten-jewellery-remodelling-v2"] && !Shopify.designMode) return;
  try {
    

function initialiseRemodellingRecognitionFilm(root) {
  root.querySelectorAll('[data-remodel-recognition-film]').forEach(frame => {
    if (frame.dataset.ready) return;
    frame.dataset.ready = 'true';
    const video = frame.querySelector('video');
    if (!video) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    let failed = false;
    video.controls = false;
    const showStill = () => { video.pause(); video.hidden = true; };
    const reconcile = () => {
      if (failed || reduce.matches) { showStill(); return; }
      if (inView && !document.hidden) {
        video.play().catch(showStill);
      } else video.pause();
    };
    video.addEventListener('playing', () => {
      if (reduce.matches || failed) showStill();
      else video.hidden = false;
    });
    video.addEventListener('error', () => { failed = true; showStill(); });
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; reconcile(); }, { threshold: 0.3 });
    observer.observe(frame);
    reduce.addEventListener('change', reconcile);
    document.addEventListener('visibilitychange', reconcile);
  });
}
initialiseRemodellingRecognitionFilm(document);
document.addEventListener('shopify:section:load', event => initialiseRemodellingRecognitionFilm(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molten-library-approved"]) return;
  try {
    
function initMoltenLibrary(root) {
  root.querySelectorAll('.lib-media').forEach(frame => {
    if (frame.dataset.libraryReady) return;
    frame.dataset.libraryReady = 'true';
    const video = frame.querySelector('video');
    if (!video) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    let failed = false;
    video.controls = false;
    const showStill = () => { video.pause(); video.hidden = true; };
    const reconcile = () => {
      if (failed || reduce.matches) { showStill(); return; }
      if (inView && !document.hidden) {
        video.play().catch(showStill);
      } else video.pause();
    };
    video.addEventListener('playing', () => {
      if (reduce.matches || failed) showStill();
      else video.hidden = false;
    });
    video.addEventListener('error', () => { failed = true; showStill(); });
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; reconcile(); }, { threshold: 0.3 });
    observer.observe(frame);
    reduce.addEventListener('change', reconcile);
    document.addEventListener('visibilitychange', reconcile);
  });
}
initMoltenLibrary(document);
document.addEventListener('shopify:section:load', event => initMoltenLibrary(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molten-signature-pdp-r1"]) return;
  try {
    
function initialiseSignatureStonesFilms(root) {
  root.querySelectorAll('[data-signature-stones-film]').forEach(frame => {
    if (frame.dataset.filmReady) return;
    const main = frame.querySelector('.signature-stones-film--main');
    if (!main) return;
    frame.dataset.filmReady = 'true';
    const compact = frame.querySelector('.signature-stones-film--compact');
    const videos = compact ? [main, compact] : [main];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const small = window.matchMedia('(max-width:1100px)');
    const failed = new Set();
    let inView = false;
    const selected = () => small.matches && compact ? compact : main;
    const still = video => { video.pause(); video.hidden = true; };
    const reconcile = () => videos.forEach(video => {
      if (video !== selected() || reduced.matches || failed.has(video)) { still(video); return; }
      if (inView && !document.hidden) video.play().catch(() => still(video));
      else video.pause();
    });
    videos.forEach(video => {
      video.controls = false;
      video.addEventListener('playing', () => {
        if (video !== selected() || reduced.matches || failed.has(video)) still(video);
        else video.hidden = false;
      });
      video.addEventListener('error', () => { failed.add(video); still(video); });
    });
    new IntersectionObserver(entries => { inView = entries[0].isIntersecting; reconcile(); }, { threshold: 0.3 }).observe(frame);
    reduced.addEventListener('change', reconcile);
    small.addEventListener('change', reconcile);
    document.addEventListener('visibilitychange', reconcile);
  });
}
initialiseSignatureStonesFilms(document);
document.addEventListener('shopify:section:load', event => initialiseSignatureStonesFilms(event.target));

  } catch(e) { console.error(e); }
})();
})();
